import React, { useState, useEffect } from "react";
import {
  Card,
  Badge,
  Button,
  Table,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  CardHeader,
} from "reactstrap";

import { api } from "../../../../api";
import Cookies from "js-cookie";
import * as XLSX from "xlsx";
import Tippy from "@tippyjs/react";

const Materials1 = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [filteredData, setFilteredData] = useState([]);
  const [dataToShow, setDataToShow] = useState([]);
  const [entriesToShow, setEntriesToShow] = useState(5);
  const [modal, setModal] = useState(false); // State to control modal visibility

  // Filter states
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [materialNameFilter, setMaterialNameFilter] = useState("");
  const [materialFilterDropdownOpen, setMaterialFilterDropdownOpen] = useState(false);
  const [dateRangeModalOpen, setDateRangeModalOpen] = useState(false);
  const [materialSearchQuery, setMaterialSearchQuery] = useState("");

  const [material, setMaterial] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [dynamo, setDynamo] = useState([]);
  const [change, setChange] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [dropdownStates, setDropdownStates] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const statusOptions = [
    { value: "Approved", label: "Accept" },
    { value: "Rejected", label: "Reject" },
  ];

  const emp_id = Cookies.get("token");
  const g_m_id = Cookies.get("token");
  // let emp_id = 1;

  const [project, setProject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        // Fetch project details
        const response = await api.get(
          `viewProjectDetails.php?g_m_id=${emp_id}&company_id=${company_id}`
        );
        if (response.data && Array.isArray(response.data)) {
          setProject(response.data);
        } else {
          setProject([]); // Default to an empty array if data is invalid
          console.warn("Invalid project data received:", response.data);
        }

        // Fetch all single materials for the company (General Manager view)
        const response2 = await api.get(
          `materialrequest.php?all=true&company_id=${company_id}`
        );
        console.log("Single materials response:", response2.data);
        const safeArray = Array.isArray(response2.data) ? response2.data : [];
        
        // Sort data in descending order by Date_Time (most recent first)
        const sortedData = safeArray.sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA; // Descending order (newest first)
        });
        
        setDynamo(sortedData);
        setMaterial((prev) => [...prev, ...sortedData]);
        setMaterialList(sortedData);
        setChange((prev) => [...prev, ...sortedData]);
        if (!Array.isArray(response2.data)) {
          console.warn("Invalid material data received (not an array):", response2.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);

        // Reset states to empty arrays in case of an error
        setProject([]);
        setMaterial([]);
        setDynamo([]);
        setMaterialList([]);
        setChange([]);
      }
    };

    fetchData();
  }, [emp_id]);

  console.log("Material1:", material);

  const [materialShow, setMaterialShow] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        // General Manager should see ALL materials from their company
        // We'll fetch all materials and filter by company_id
        const response = await api.get(`uploadMaterials.php?company_id=${company_id}&all=true`);
        console.log("API Response for all company materials:", response.data);

        if (Array.isArray(response.data)) {
          // Sort uploaded materials in descending order by Date_Time
          const sortedUploadedData = response.data.sort((a, b) => {
            const dateA = new Date(a.Date_Time);
            const dateB = new Date(b.Date_Time);
            return dateB - dateA; // Descending order (newest first)
          });
          
          setMaterial((prev) => {
            const combined = [...prev, ...sortedUploadedData];
            // Re-sort the combined data to maintain descending order
            return combined.sort((a, b) => {
              const dateA = new Date(a.Date_Time);
              const dateB = new Date(b.Date_Time);
              return dateB - dateA;
            });
          });
          
          setChange((prev) => {
            const combined = [...prev, ...sortedUploadedData];
            // Re-sort the combined data to maintain descending order
            return combined.sort((a, b) => {
              const dateA = new Date(a.Date_Time);
              const dateB = new Date(b.Date_Time);
              return dateB - dateA;
            });
          });
          
          setMaterialShow((prev) => {
            const combined = [...prev, ...sortedUploadedData];
            // Re-sort the combined data to maintain descending order
            return combined.sort((a, b) => {
              const dateA = new Date(a.Date_Time);
              const dateB = new Date(b.Date_Time);
              return dateB - dateA;
            });
          });
        } else {
          console.error("response.data is not an array:", response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [emp_id, g_m_id]);

  console.log("Material2:", material);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // 1. Fetch Project List
  //       const projectResponse = await api.get(`viewProjectDetails.php?g_m_id=${emp_id}`);
  //       if (Array.isArray(projectResponse.data)) {
  //         setProject(projectResponse.data);
  //       }

  //       // 2. Fetch Material Lists (Uploaded + Default)
  //       const [matListResponse, uploadMatResponse] = await Promise.all([
  //         api.get(`matListBasedOnProject.php?g_m_id=${emp_id}`),
  //         api.get(`uploadMaterials.php?${g_m_id ? `g_m_id=${g_m_id}` : `emp_id=${emp_id}`}`)
  //       ]);

  //       console.log('matListResponse:', matListResponse.data);
  //       console.log('uploadMatResponse:', uploadMatResponse.data);

  //       const matListData = Array.isArray(matListResponse.data) ? matListResponse.data : [];
  //       const uploadMatData = Array.isArray(uploadMatResponse.data) ? uploadMatResponse.data : [];

  //       // 3. Format data from both sources before combining
  //       const formattedMatListData = matListData.map(item => ({
  //         m_id: item.m_id,
  //         mat_name: item.mat_name,
  //         mat_quantity: item.mat_quantity,
  //         mat_money: item.mat_money,
  //         Date_Time: item.Date_Time,
  //         Priority: item.Priority,
  //         store_status: item.store_status,
  //         files: item.files,
  //         p_id: item.p_id,
  //         mat_status: item.mat_status,
  //         store_report: item.store_report,
  //         source: 'matList'
  //       }));

  //       const formattedUploadData = uploadMatData.map(item => ({
  //         m_id: item.m_id,
  //         mat_name: item.material_name || item.mat_name, // Check both possible field names
  //         mat_quantity: item.quantity || item.mat_quantity,
  //         mat_money: item.budget || item.mat_money,
  //         Date_Time: item.date || item.Date_Time,
  //         Priority: item.priority || item.Priority,
  //         store_status: item.status || item.store_status || 'Pending',
  //         files: item.files || '',
  //         p_id: item.p_id,
  //         mat_status: item.mat_status || 'Pending',
  //         store_report: item.store_report || '',
  //         source: 'upload'
  //       }));

  //       // 4. Combine and deduplicate
  //       const combinedData = [...formattedMatListData];
  //       formattedUploadData.forEach(uploadItem => {
  //         if (!combinedData.some(item => item.m_id === uploadItem.m_id)) {
  //           combinedData.push(uploadItem);
  //         }
  //       });

  //       // 5. Final formatting and default values
  //       const finalFormattedData = combinedData.map(item => ({
  //         ...item,
  //         mat_name: item.mat_name ||item.mat_fileName ,
  //         mat_quantity: item.mat_quantity || '0',
  //         mat_money: item.mat_money || '0',
  //         Date_Time: item.Date_Time ? new Date(item.Date_Time).toISOString() : new Date().toISOString(),
  //         Priority: item.Priority || 'Low',
  //         store_status: item.store_status || 'Pending'
  //       }));

  //       console.log('Final Formatted Data:', finalFormattedData);

  //       setDynamo(finalFormattedData);
  //       setMaterial(finalFormattedData.slice(0, entriesToShow));
  //       setMaterialList(finalFormattedData);
  //       setChange(finalFormattedData);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //       setProject([]);
  //       setDynamo([]);
  //       setMaterial([]);
  //       setMaterialList([]);
  //       setChange([]);
  //     }
  //   };

  //   fetchData();
  // }, [emp_id, g_m_id, entriesToShow]);

  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleModalView = () => {
    setModalOpen(!modalOpen);
  };

  const [selectedproject, setselectedproject] = useState();
  const [modalEmployee, setModalEmployee] = useState(null);

  // Multiple materials modal states
  const [isMultipleMaterials, setIsMultipleMaterials] = useState(false);
  const [multipleMaterialsData, setMultipleMaterialsData] = useState(null);
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [modalEntriesPerPage, setModalEntriesPerPage] = useState(5);
  const [modalEntriesDropdownOpen, setModalEntriesDropdownOpen] = useState(false);

  const handleProjectSelection = async (p_id, p_name) => {
    setselectedproject(p_name);
    const company_id = Cookies.get('company_id');
    try {
      if (p_id === "all") {
        const response = await api.get(
          `matListBasedOnProject.php?g_m_id=${emp_id}&company_id=${company_id}`
        );
        const response2 = await api.get(`uploadMaterials.php?g_m_id=${emp_id}&company_id=${company_id}`);
        console.log("API Response:", response.data);

        const safeArray1 = Array.isArray(response.data) ? response.data : [];
        const safeArray2 = Array.isArray(response2.data) ? response2.data : [];
        
        if (!Array.isArray(response.data)) {
          console.error("response.data is not an array:", response.data);
        }
        if (!Array.isArray(response2.data)) {
          console.error("response2.data is not an array:", response2.data);
        }
        
        // Sort both arrays in descending order by Date_Time
        const sortedArray1 = safeArray1.sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA;
        });
        
        const sortedArray2 = safeArray2.sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA;
        });
        
        // Combine and re-sort to maintain descending order
        const combinedData = [...sortedArray1, ...sortedArray2].sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA;
        });
        
        setMaterial(combinedData);
        setChange(combinedData);
      } else if (p_id) {
        // Fetch both single materials and uploaded materials for the specific project
        const response = await api.get(
          `matListBasedOnProject.php?p_id=${p_id}&company_id=${company_id}`
        );
        const response2 = await api.get(`uploadMaterials.php?all=true&company_id=${company_id}`);
        console.log("Single materials API Response:", response.data);
        console.log("Uploaded materials API Response:", response2.data);

        const safeArray1 = Array.isArray(response.data) ? response.data : [];
        const safeArray2 = Array.isArray(response2.data) ? response2.data : [];
        
        if (!Array.isArray(response.data)) {
          console.error("response.data is not an array:", response.data);
        }
        if (!Array.isArray(response2.data)) {
          console.error("response2.data is not an array:", response2.data);
        }
        
        // Filter uploaded materials by the selected project
        const filteredArray2 = safeArray2.filter(item => item.p_id == p_id);
        
        // Sort both arrays in descending order by Date_Time
        const sortedArray1 = safeArray1.sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA;
        });
        
        const sortedArray2 = filteredArray2.sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA;
        });
        
        // Combine and re-sort to maintain descending order
        const combinedData = [...sortedArray1, ...sortedArray2].sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA;
        });
        
        setMaterial(combinedData);
        setChange(combinedData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // const handleProjectSelection = async (p_id, p_name) => {
  //   setselectedproject(p_name);
  //   setCurrentPage(1); // Reset to first page when changing projects

  //   try {
  //     let url;
  //     if (p_id === "all") {
  //       url = `matListBasedOnProject.php?g_m_id=${emp_id}`;
  //     } else {
  //       url = `matListBasedOnProject.php?p_id=${p_id}`;
  //     }

  //     const response = await api.get(url);

  //     if (response.data && Array.isArray(response.data)) {
  //       const materialData = response.data.map(item => ({
  //         ...item,
  //         mat_name: item.mat_name || 'N/A',
  //         mat_money: item.mat_money || 'N/A',
  //         mat_quantity: item.mat_quantity || 'N/A',
  //         Date_Time: item.Date_Time || 'N/A',
  //         Priority: item.Priority || 'N/A',
  //         store_status: item.store_status || 'Pending'
  //       }));

  //       setDynamo(materialData);
  //       setMaterial(materialData.slice(0, entriesToShow));
  //       setChange(materialData);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching materials:", error);
  //     setMaterial([]);
  //     setChange([]);
  //   }
  // };

  const handleDropdownToggle = (index) => {
    setDropdownStates((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const handleItemClick = (item) => {
    setreport({
      gm_id: item.mat_id || item.m_id, // Always use gm_id for GM action
      status: "",
      description: ""
    });
    toggleModal();
  };

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleStatusAction = async (e) => {
    e.preventDefault();
    if (!report.gm_id && !report.id) {
      alert("No material selected for GM action.");
      return;
    }
    const company_id = Cookies.get('company_id');
    if (!company_id) {
      alert("Company ID is missing. Please log in again or contact admin.");
      return;
    }
    try {
      const response = await api.post(`materialreport.php`, { ...report, company_id });
      console.log("Data sent successfully:", response.data);
      setSuccessMessage('Status updated successfully!');
      setShowSuccessAlert(true);
      toggleModal();
    } catch (error) {
      console.error("Error submitting data:", error);
      setSuccessMessage('Error updating status. Please try again.');
      setShowSuccessAlert(true);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "pending":
        return <Badge color="warning">{status}</Badge>;
      case "Approved":
        return <Badge color="success">{status}</Badge>;
      case "Rejected":
        return <Badge color="danger">{status}</Badge>;
      default:
        return <Badge color="secondary">{status}</Badge>;
    }
  };

  const [report, setreport] = useState();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setreport((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    console.log(report);
  };

  //Pagination code part 2  goes here

  const [projectDropdownOpen1, setProjectDropdownOpen1] = useState(false);
  const totalPages = Math.ceil(dynamo.length / entriesToShow);

  const toggleProjectDropdown1 = () => {
    setProjectDropdownOpen1(!projectDropdownOpen1);
  };

  const toggleDateRangeModal = () => {
    setDateRangeModalOpen(!dateRangeModalOpen);
  };

  const toggleMaterialFilterDropdown = () => {
    setMaterialFilterDropdownOpen(!materialFilterDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(value === "All" ? change.length : Number(value));
  };

  // Get unique material names for filter dropdown with search
  const getUniqueMaterialNames = () => {
    let names = [...new Set(change.map(item => item.mat_name || item.mat_fileName).filter(Boolean))];
    
    // Apply search filter if there's a search query
    if (materialSearchQuery.trim()) {
      names = names.filter(name => 
        name.toLowerCase().includes(materialSearchQuery.toLowerCase())
      );
    }
    
    return names.sort();
  };

  // Apply filters
  const applyFilters = (data) => {
    let filtered = [...data];

    // Apply date range filter
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        if (item.Date_Time) {
          // Parse the item date and normalize to YYYY-MM-DD format
          const itemDate = new Date(item.Date_Time);
          const itemDateStr = itemDate.toISOString().split('T')[0]; // Get YYYY-MM-DD format
          
          if (startDate && endDate) {
            // Both start and end date selected
            // Normalize both dates to YYYY-MM-DD format for accurate comparison
            const startDateStr = startDate; // Already in YYYY-MM-DD format
            const endDateStr = endDate; // Already in YYYY-MM-DD format
            
            // For same day selection (start === end), we want to include the entire day
            if (startDateStr === endDateStr) {
              return itemDateStr === startDateStr;
            } else {
              return itemDateStr >= startDateStr && itemDateStr <= endDateStr;
            }
          } else if (startDate) {
            // Only start date selected - from start date to current date
            const startDateStr = startDate;
            return itemDateStr >= startDateStr;
          } else if (endDate) {
            // Only end date selected - from beginning to end date
            const endDateStr = endDate;
            return itemDateStr <= endDateStr;
          }
        }
        return false;
      });
    }

    // Apply material name filter
    if (materialNameFilter) {
      filtered = filtered.filter(item => {
        const materialName = item.mat_name || item.mat_fileName || '';
        return materialName.toLowerCase().includes(materialNameFilter.toLowerCase());
      });
    }

    return filtered;
  };

  // Clear all filters
  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
    setMaterialNameFilter("");
    setMaterialSearchQuery("");
  };

  // Apply date range filter
  const applyDateRange = () => {
    setDateRangeModalOpen(false);
  };

  // Get date range display text
  const getDateRangeText = () => {
    if (startDate && endDate) {
      return `Date: ${new Date(startDate).toLocaleDateString()} - ${new Date(endDate).toLocaleDateString()}`;
    } else if (startDate) {
      return `From: ${new Date(startDate).toLocaleDateString()}`;
    } else if (endDate) {
      return `Until: ${new Date(endDate).toLocaleDateString()}`;
    }
    return "Filter by Date Range";
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const getSerialNumber = (index) => {
    return (currentPage - 1) * entriesToShow + index + 1;
  };

  useEffect(() => {
    if (Array.isArray(change)) {
      setMaterial(
        change.slice(
          (currentPage - 1) * entriesToShow,
          currentPage * entriesToShow
        )
      );
    } else {
      setMaterial([]); // Handle case where change is not an array
    }
    console.log("Material 3:", material);
  }, [entriesToShow, currentPage, change]);

  useEffect(() => {
    if (Array.isArray(change)) {
      let filteredData = [...change];

      // Apply search filter
      if (searchQuery.trim() !== "") {
        const searchQueryLower = searchQuery.toLowerCase();
        filteredData = filteredData.filter((item) => {
          const matchName =
            item?.mat_name?.toLowerCase()?.includes(searchQueryLower) || false;
          const matchStatus =
            item?.mat_status?.toLowerCase()?.includes(searchQueryLower) ||
            false;
          const matchFileName =
            item?.mat_fileName?.toLowerCase()?.includes(searchQueryLower) ||
            false;

          return matchName || matchStatus || matchFileName;
        });
      }

      // Apply date and material name filters
      filteredData = applyFilters(filteredData);
      
      // Sort filtered data in descending order by Date_Time
      const sortedFilteredData = filteredData.sort((a, b) => {
        const dateA = new Date(a.Date_Time);
        const dateB = new Date(b.Date_Time);
        return dateB - dateA; // Descending order (newest first)
      });
      
      setMaterial(sortedFilteredData.slice(0, entriesToShow));
    } else {
      setMaterial([]);
    }
  }, [searchQuery, entriesToShow, currentPage, change, startDate, endDate, materialNameFilter]);

  console.log("change:", change);

  const handleDownload = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "material_list";

    // Define the columns you want to keep and their new names
    const columnMapping = {
      mat_name: "Material Name",
      mat_money: "Budget",
      mat_quantity: "Quantity",
      Priority: "Priority",
      Date_Time: "Date",
    };

    // Filter the material array to only include the desired columns and map to new column names
    const filteredMaterial = material.map((item) => {
      let filteredItem = {};
      Object.keys(columnMapping).forEach((originalColumn) => {
        if (item[originalColumn] !== undefined) {
          filteredItem[columnMapping[originalColumn]] = item[originalColumn];
        }
      });
      return filteredItem;
    });

    const ws = XLSX.utils.json_to_sheet(filteredMaterial);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    // Apply bold and background color to headers
    const headerCellStyle = {
      font: { bold: true },
      fill: { bgColor: { indexed: 64 } },
    };
    Object.keys(ws)
      .filter((key) => key.startsWith("A1"))
      .forEach((key) => (ws[key].s = headerCellStyle));

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    const excelUrl = URL.createObjectURL(excelData);
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const [activeIndex1, setActiveIndex1] = useState(0);
  const [animating, setAnimating] = useState(false);
  const imagesString = modalEmployee?.files;
  const imagesArray = imagesString ? imagesString.split(",") : [];

  const next1 = () => {
    if (animating || imagesArray.length === 0) return;
    const nextIndex =
      activeIndex1 === imagesArray.length - 1 ? 0 : activeIndex1 + 1;
    setActiveIndex1(nextIndex);
  };

  const previous1 = () => {
    if (animating || imagesArray.length === 0) return;
    const nextIndex =
      activeIndex1 === 0 ? imagesArray.length - 1 : activeIndex1 - 1;
    setActiveIndex1(nextIndex);
  };

  const goToIndex1 = (newIndex) => {
    if (animating || imagesArray.length === 0) return;
    setActiveIndex1(newIndex);
  };

  // Multiple materials functions
  const handleDownloadMultipleMaterials = () => {
    if (!multipleMaterialsData) return;

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "multiple_materials_list";

    const materialsForExport = multipleMaterialsData.materials.map((material, index) => ({
      "Sr. No": index + 1,
      "Material Name": material.mat_name || "N/A",
      "Quantity": material.mat_quantity || "N/A",
      "Budget": material.mat_money || "N/A",
      "Unit Price": parseFloat(material.mat_money) || 0,
      "Total": (parseFloat(material.mat_quantity) || 0) * (parseFloat(material.mat_money) || 0)
    }));

    const ws = XLSX.utils.json_to_sheet(materialsForExport);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    const excelUrl = URL.createObjectURL(excelData);
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const getModalPaginatedMaterials = () => {
    const startIndex = (modalCurrentPage - 1) * modalEntriesPerPage;
    const endIndex = startIndex + modalEntriesPerPage;
    return multipleMaterialsData.materials.slice(startIndex, endIndex);
  };

  const getModalTotalPages = () => {
    return Math.ceil(multipleMaterialsData.materials.length / modalEntriesPerPage);
  };

  const handleModalPageChange = (page) => {
    setModalCurrentPage(page);
  };

  const handleModalEntriesChange = (value) => {
    setModalEntriesPerPage(value === "All" ? multipleMaterialsData.materials.length : Number(value));
    setModalCurrentPage(1);
  };

  const getModalSerialNumber = (index) => {
    return (modalCurrentPage - 1) * modalEntriesPerPage + index + 1;
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      case "pending":
        return "warning";
      default:
        return "secondary";
    }
  };

  const slides1 = imagesArray
    .map((image, index) => {
      // Check if the image exists
      try {
        require(`../../../images/${image}`);
      } catch (error) {
        // Handle the case where the image doesn't exist
        console.error(`Image ${image} not found`);
        return null; // Return null to indicate that the slide should be skipped
      }

      return (
        <CarouselItem
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
          key={index}
        >
          <div
            className="profile-image-container"
            style={{
              width: "376px",
              height: "256px",
              border: "2px solid black",
              borderRadius: "9%",
              overflow: "hidden",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
              margin: "0 auto",
            }}
          >
            <img
              id=""
              alt={`Uploaded Image ${index + 1 + image}`}
              src={window.location.hostname === 'localhost'
                  ? require(`../../../images/${image}`)
                  : `/images/${image}`}
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </div>
          <CarouselCaption captionText="" captionHeader="" />
        </CarouselItem>
      );
    })
    .filter((slide) => slide !== null); // Filter out null values

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="">
            <Col>
              <Dropdown
                isOpen={projectDropdownOpen}
                toggle={() => setProjectDropdownOpen(!projectDropdownOpen)}
              >
                <DropdownToggle caret>
                  {selectedproject ? selectedproject : "All Projects"}
                </DropdownToggle>
                <DropdownMenu left>
                  <DropdownItem
                    onClick={() =>
                      handleProjectSelection("all", "All Projects")
                    }
                  >
                    All Projects
                  </DropdownItem>
                  {Array.isArray(project) ? (
                    project.map((project) => (
                      <DropdownItem
                        key={project.p_name}
                        onClick={() =>
                          handleProjectSelection(project.p_id, project.p_name)
                        }
                      >
                        {project.p_name}
                      </DropdownItem>
                    ))
                  ) : (
                    <DropdownItem>No Projects Found</DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
            </Col>

            <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
              <h1>Material Details</h1>
            </Col>
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex ">
              <Form className="navbar-search  form-inline ml-5 d-none d-md-flex ml-lg-auto ">
                <FormGroup className="mb-0 ml-6">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-search" style={{color: 'black'}}/>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Search Materials"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
              </Form>
            </Col>
          </Row>
          <marquee
            behavior="scroll"
            direction="right"
            style={{ height: "58px" }}
          >
            {/* <img src={require("../../assets/img/brand//240_F_364017781_DR0bENAGus0GPESus7E2w4JaT7wzIZ1M-removebg-preview.png")} style={{ height: '100px' ,marginbottom:'-17px' }} alt="Delivery Truck" /> */}
            <img
              src={require("../../assets/img/brand/delivery-truck-1--unscreen.gif")}
              style={{ height: "80px", marginbottom: "-17px" }}
              alt="Delivery Truck"
            />
            Material Delivery
          </marquee>
          <Row className="">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="shadow" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}>
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Material List</h3>
                    </div>
                    <div className="d-flex justify-content-end align-items-center flex-wrap">
                      {/* Date Range Filter */}
                      <div className="mr-2 mb-2">
                        <Button
                          size="sm"
                          color="info"
                          onClick={toggleDateRangeModal}
                          style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                        >
                          <i className="fas fa-calendar-alt mr-1"></i>
                          {getDateRangeText()}
                        </Button>
                      </div>

                      {/* Material Name Filter */}
                      <div className="mr-2 mb-2">
                        <Dropdown
                          isOpen={materialFilterDropdownOpen}
                          toggle={toggleMaterialFilterDropdown}
                        >
                          <DropdownToggle caret size="sm">
                            {materialNameFilter ? `Material: ${materialNameFilter}` : "Filter by Material"}
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '300px', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                            {/* Search Bar Inside Dropdown */}
                            <div className="mb-2">
                              <Input
                                type="text"
                                placeholder="Search materials..."
                                value={materialSearchQuery || ''}
                                onChange={(e) => setMaterialSearchQuery(e.target.value)}
                                style={{ fontSize: '13px', height: '32px' }}
                              />
                            </div>
                            <DropdownItem 
                              onClick={() => {
                                setMaterialNameFilter("");
                                setMaterialSearchQuery("");
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              All Materials
                            </DropdownItem>
                            {getUniqueMaterialNames().length > 0 ? (
                              getUniqueMaterialNames().map((name, index) => (
                                <DropdownItem
                                  key={index}
                                  onClick={() => {
                                    setMaterialNameFilter(name);
                                    setMaterialSearchQuery("");
                                  }}
                                  style={{ 
                                    padding: '6px 12px', 
                                    fontSize: '13px',
                                    backgroundColor: materialNameFilter === name ? '#f8f9fa' : 'transparent',
                                    fontWeight: materialNameFilter === name ? 'bold' : 'normal'
                                  }}
                                >
                                  {name}
                                </DropdownItem>
                              ))
                            ) : (
                              <DropdownItem disabled style={{ padding: '6px 12px', fontSize: '13px' }}>
                                <small className="text-muted">No materials found</small>
                              </DropdownItem>
                            )}
                          </DropdownMenu>
                        </Dropdown>
                      </div>

                      {/* Clear Filters Button */}
                      {(startDate || endDate || materialNameFilter) && (
                        <div className="mr-2 mb-2">
                          <Button
                            size="sm"
                            color="secondary"
                            onClick={clearFilters}
                          >
                            Clear Filters
                          </Button>
                        </div>
                      )}

                      {/* Show Entries */}
                      <div className="mr-2 mb-2">
                        <Dropdown
                          isOpen={projectDropdownOpen1}
                          toggle={toggleProjectDropdown1}
                        >
                          <DropdownToggle caret size="sm">
                            Show Entries: {entriesToShow === change.length ? "All" : entriesToShow}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem onClick={() => handleEntriesChange(5)}>
                              5
                            </DropdownItem>
                            <DropdownItem onClick={() => handleEntriesChange(10)}>
                              10
                            </DropdownItem>
                            <DropdownItem onClick={() => handleEntriesChange("All")}>
                              All
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>

                      {/* Download Button */}
                      <div className="mb-2">
                        <button
                          className="btn btn-success"
                          onClick={handleDownload}
                          style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Sr. No</th>
                      <th scope="col">Project Name</th>
                      <th scope="col">Material Name</th>
                      <th scope="col">Request By</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Budget</th>
                      <th scope="col">Date</th>
                      <th scope="col">Priority</th>
                      {/* <th scope="col">Employee ID</th> */}
                      <th scope="col">Status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(material) && material.length > 0 ? (
                      material.map((item, index) => (
                        <tr key={item.m_id || index}>
                          <td>{getSerialNumber(index)}</td>         
                          <td>{item.p_name || "N/A"}</td>
                          <td>{item.mat_name || item.mat_fileName}</td>
                          <td>{item.emp_name || "N/A"}</td>
                          <td>{item.mat_quantity || "N/A"}</td>
                          <td>{item.mat_money || "N/A"}</td>
                          <td>
                            {new Date(item.Date_Time).toLocaleDateString()}
                          </td>
                          <td>
                            <Badge
                              color={
                                item.Priority?.toLowerCase() === "high"
                                  ? "danger"
                                  : "warning"
                              }
                            >
                              {item.Priority || "Low"}
                            </Badge>
                          </td>
                          {/* <td>{item.emp_id || "N/A"}</td> */}
                          <td>
                            <Badge
                              color={getStatusColor(
                                item.store_status || item.mat_status
                              )}
                            >
                              {item.store_status || "Pending"}
                            </Badge>
                          </td>
                          <td>
                            <Button
                              // color="info"
                              style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                              size="sm"
                              className="mr-2"
                              onClick={() => {
                                if (item.mat_data) {
                                  const matData = JSON.parse(item.mat_data);
                                  
                                  // Check if this is multiple materials (more than 1)
                                  if (matData.length > 1) {
                                    // Multiple materials - show table view
                                    const multipleData = {
                                      materials: matData,
                                      metadata: {
                                        Priority: item.Priority,
                                        Date_Time: item.Date_Time,
                                        mat_status: item.mat_status,
                                        store_status: item.store_status,
                                        gm_report: item.gm_report,
                                        store_report: item.store_report,
                                        files: item.files
                                      }
                                    };
                                    setMultipleMaterialsData(multipleData);
                                    setIsMultipleMaterials(true);
                                    setModalCurrentPage(1);
                                    setModalEntriesPerPage(5);
                                  } else {
                                    // Single material - show regular view
                                    const merged = {
                                      mat_name: matData[0].mat_name,
                                      mat_money: matData[0].mat_money,
                                      mat_quantity: matData[0].mat_quantity,
                                      Priority: item.Priority,
                                      Date_Time: item.Date_Time,
                                      mat_status: item.mat_status,
                                      store_status: item.store_status,
                                      gm_report: item.gm_report,
                                      store_report: item.store_report,
                                      files: item.files
                                    };
                                    setModalEmployee(merged);
                                    setIsMultipleMaterials(false);
                                  }
                                } else {
                                  // Single material from regular request
                                  setModalEmployee(item);
                                  setIsMultipleMaterials(false);
                                }
                                toggleModalView();
                              }}
                            >
                              <Tippy content="View"><i className="fa-solid fa-eye"></i></Tippy>
                            </Button>
                            <Button
                              // color="success"
                              size="sm"
                              onClick={() => handleItemClick(item)}
                              style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                            >
                              Set Action
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="11" className="text-center">
                          No materials available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <nav className="mt-3">
                  <ul className="pagination justify-content-center">
                    <li className="page-item">
                      <a
                        href="#"
                        className="page-link text-primary"
                        onClick={prePage}
                        disabled={currentPage === 1}
                      >
                        Prev
                      </a>
                    </li>
                    <li className="page-item">
                      <a
                        href="#"
                        className="page-link text-primary"
                        onClick={nextPage}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          <h2 style={{ fontWeight: "bolder" }}>Status Action</h2>
        </ModalHeader>
        <ModalBody>
          {/* Your form elements go here */}
          <Form onSubmit={handleStatusAction}>
            <FormGroup>
              <Label for="exampleSelect">Select</Label>
              <Input
                className="form-control-alternative"
                id="input-status"
                type="select"
                name="status"
                onChange={handleInputChange}
                
              >
                <option style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} value="" >Select Status</option>
                {statusOptions.map((option) => (
                  <option  key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="exampleText">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="exampleText"
                onChange={handleInputChange}
              />
            </FormGroup>
            <Row>
              <Col lg="12" style={{ textAlign: "center" }}>
                <Button style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} type="submit">
                  Submit
                </Button>
              </Col>
            </Row>
            {/* Add more form fields as needed */}
          </Form>
        </ModalBody>
      </Modal>

      {modalEmployee && modalEmployee && (
        <Modal isOpen={modalOpen} toggle={toggleModalView}>
          <ModalHeader toggle={toggleModalView}>Material View</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <label
                    className="border p-2 rounded font-weight-bold"
                    style={{ width: "155px" }}
                  >
                    Material Name
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.mat_name || modalEmployee.mat_fileName}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Budget
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.mat_money}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Quantity
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.mat_quantity}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Priority
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.Priority}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Date
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.Date_Time}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    General Manager
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.mat_status}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Store Manager
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.store_status || "N/A"}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Action
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.store_report || "N/A"}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Uploaded Images
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <Carousel
                    activeIndex={activeIndex1}
                    next={next1}
                    previous={previous1}
                  >
                    <CarouselIndicators
                      items={imagesArray}
                      activeIndex={activeIndex1}
                      onClickHandler={goToIndex1}
                    />

                    {slides1}

                    <CarouselControl
                      direction="prev"
                      directionText="Previous"
                      onClickHandler={previous1}
                    />
                    <CarouselControl
                      direction="next"
                      directionText="Next"
                      onClickHandler={next1}
                    />
                  </Carousel>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}

      {/* Multiple Materials Modal */}
      {multipleMaterialsData && isMultipleMaterials && (
        <Modal isOpen={modalOpen} toggle={toggleModalView} size="xl">
          <ModalHeader toggle={toggleModalView}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <span>Multiple Materials View ({multipleMaterialsData.materials.length} materials)</span>
              <Button
                color="success"
                size="sm"
                onClick={handleDownloadMultipleMaterials}
                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
              >
                <i className="fas fa-download mr-1"></i>
                Download Excel
              </Button>
            </div>
          </ModalHeader>
          <ModalBody>
            {/* Metadata Section */}
            <div className="row mb-4">
              <div className="col-md-12">
                <h6 className="text-muted mb-3">Request Information</h6>
                <div className="row">
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Priority</small>
                      <strong>{multipleMaterialsData.metadata.Priority || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Date</small>
                      <strong>{multipleMaterialsData.metadata.Date_Time || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">General Manager</small>
                      <strong>{multipleMaterialsData.metadata.mat_status || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Store Manager</small>
                      <strong>{multipleMaterialsData.metadata.store_status || "N/A"}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Materials Table */}
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="text-muted mb-0">Materials List</h6>
                  {multipleMaterialsData.materials.length > 5 && (
                    <div className="d-flex align-items-center">
                      <span className="mr-2 text-muted small">Show:</span>
                      <Dropdown
                        isOpen={modalEntriesDropdownOpen}
                        toggle={() => setModalEntriesDropdownOpen(!modalEntriesDropdownOpen)}
                        size="sm"
                      >
                        <DropdownToggle caret size="sm" className="px-3">
                          {modalEntriesPerPage === multipleMaterialsData.materials.length ? "All" : modalEntriesPerPage}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => handleModalEntriesChange(5)}>5</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange(10)}>10</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange(15)}>15</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange("All")}>All</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  )}
                </div>
                <div className="table-responsive" style={{maxHeight: '400px', overflowY: 'auto'}}>
                  <Table striped bordered hover size="sm">
                    <thead className="thead-light" style={{position: 'sticky', top: 0, zIndex: 1}}>
                      <tr>
                        <th style={{width: '5%'}}>Sr. No</th>
                        <th style={{width: '35%'}}>Material Name</th>
                        <th style={{width: '15%'}}>Quantity</th>
                        <th style={{width: '15%'}}>Budget</th>
                        <th style={{width: '10%'}}>Unit Price</th>
                        <th style={{width: '20%'}}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getModalPaginatedMaterials().map((material, index) => {
                        const quantity = parseFloat(material.mat_quantity) || 0;
                        const price = parseFloat(material.mat_money) || 0;
                        const total = quantity * price;
                        
                        return (
                          <tr key={index}>
                            <td>{getModalSerialNumber(index)}</td>
                            <td>
                              <div style={{wordBreak: 'break-word'}}>
                                {material.mat_name || "N/A"}
                              </div>
                            </td>
                            <td>{material.mat_quantity || "N/A"}</td>
                            <td>₹{material.mat_money || "N/A"}</td>
                            <td>₹{price.toFixed(2)}</td>
                            <td>₹{total.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr className="font-weight-bold" style={{backgroundColor: '#f8f9fa'}}>
                        <td colSpan="5" className="text-right">Total Budget:</td>
                        <td>
                          ₹{multipleMaterialsData.materials.reduce((sum, material) => {
                            const quantity = parseFloat(material.mat_quantity) || 0;
                            const price = parseFloat(material.mat_money) || 0;
                            return sum + (quantity * price);
                          }, 0).toFixed(2)}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
                
                {/* Pagination Controls */}
                {multipleMaterialsData.materials.length > 5 && getModalTotalPages() > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted small">
                      Showing {((modalCurrentPage - 1) * modalEntriesPerPage) + 1} to {Math.min(modalCurrentPage * modalEntriesPerPage, multipleMaterialsData.materials.length)} of {multipleMaterialsData.materials.length} materials
                    </div>
                    <nav>
                      <ul className="pagination pagination-sm mb-0">
                        <li className={`page-item ${modalCurrentPage === 1 ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handleModalPageChange(modalCurrentPage - 1)}
                            disabled={modalCurrentPage === 1}
                          >
                            Previous
                          </button>
                        </li>
                        {Array.from({ length: getModalTotalPages() }, (_, i) => i + 1).map((pageNumber) => (
                          <li key={pageNumber} className={`page-item ${pageNumber === modalCurrentPage ? 'active' : ''}`}>
                            <button
                              className="page-link"
                              onClick={() => handleModalPageChange(pageNumber)}
                              style={{
                                backgroundColor: pageNumber === modalCurrentPage ? '#d86f89' : 'transparent',
                                borderColor: pageNumber === modalCurrentPage ? '#d86f89' : '#dee2e6',
                                color: pageNumber === modalCurrentPage ? 'white' : '#007bff'
                              }}
                            >
                              {pageNumber}
                            </button>
                          </li>
                        ))}
                        <li className={`page-item ${modalCurrentPage === getModalTotalPages() ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handleModalPageChange(modalCurrentPage + 1)}
                            disabled={modalCurrentPage === getModalTotalPages()}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>

            {/* Images Section */}
            {multipleMaterialsData.metadata.files && (
              <div className="row mt-4">
                <div className="col-md-12">
                  <h6 className="text-muted mb-3">Uploaded Images</h6>
                  <Carousel
                    activeIndex={activeIndex1}
                    next={next1}
                    previous={previous1}
                  >
                    <CarouselIndicators
                      items={multipleMaterialsData.metadata.files.split(",")}
                      activeIndex={activeIndex1}
                      onClickHandler={goToIndex1}
                    />
                    {slides1}
                    <CarouselControl
                      direction="prev"
                      directionText="Previous"
                      onClickHandler={previous1}
                    />
                    <CarouselControl
                      direction="next"
                      directionText="Next"
                      onClickHandler={next1}
                    />
                  </Carousel>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}

      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => {
                setShowSuccessAlert(false);
                window.location.reload();
              }}
            >OK</Button>
          </div>
        </div>
      )}

      {/* Date Range Filter Modal */}
      <Modal isOpen={dateRangeModalOpen} toggle={toggleDateRangeModal}>
        <ModalHeader toggle={toggleDateRangeModal}>
          <i className="fas fa-calendar-alt mr-2"></i>
          Filter by Date Range
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="startDate">Start Date</Label>
                  <Input
                    type="date"
                    id="startDate"
                    name="startDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="Select start date"
                  />
                  <small className="text-muted">
                    Leave empty to show from beginning
                  </small>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="endDate">End Date</Label>
                  <Input
                    type="date"
                    id="endDate"
                    name="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="Select end date"
                  />
                  <small className="text-muted">
                    Leave empty to show until current date
                  </small>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="d-flex justify-content-between">
                  <Button
                    color="secondary"
                    onClick={clearFilters}
                    size="sm"
                  >
                    Clear Dates
                  </Button>
                  <div>
                    <Button
                      color="secondary"
                      onClick={toggleDateRangeModal}
                      className="mr-2"
                      size="sm"
                    >
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      onClick={applyDateRange}
                      size="sm"
                      style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                    >
                      Apply Filter
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Materials1;
